import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Button, Row, Col, Space, message, Spin } from 'antd';
import { getDepartamentos, getMunicipios, getTiposZonaInfluencia, createZonaInfluencia
} from '../../services/participant/zonaInfluenciaService';

const FormZonaInfluencia = ({
    onSuccess
}) => {

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [departamentos, setDepartamentos] = useState([]);
    const [municipios, setMunicipios] = useState([]);
    const [tipos, setTipos] = useState([]);

    const loadData = async () => {
        setLoading(true);
        const [
            deptosResponse,
            tiposResponse
        ] = await Promise.all([
            getDepartamentos(),
            getTiposZonaInfluencia()
        ]);
        if (deptosResponse.status === 200) {
            setDepartamentos(
                deptosResponse.data
            );
        }
        if (tiposResponse.status === 200) {
            setTipos(
                tiposResponse.data
            );
        }
        setLoading(false);
    };

    useEffect(() => {
        loadData();
    }, []);

    const handleDepartamento = async (
        value
    ) => {
        form.setFieldValue(
            'id_municipio',
            null
        );
        const response = await getMunicipios(
            value
        );
        if (response.status === 200) {
            setMunicipios(
                response.data
            );
        }
    };

    const onFinish = async (
        values
    ) => {
        setLoading(true);
        const response = await createZonaInfluencia(
            values
        );
        if (  response.status === 201) {
            message.success(
                'Zona creada correctamente'
            );
            form.resetFields();
            onSuccess(
    response.data
);
        } else {
            message.error(
                response.message
            );
        }
        setLoading(false);
    };


    return (
        <Spin spinning={loading}>
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <Row gutter={[16, 16]}>
                    {/* ZONA */}
                    <Col xs={24} md={24}>
                        <Form.Item
                            label="Zona de Influencia"
                            name="zona_influencia"
                            rules={[
                                {
                                    required: true,
                                    message:
                                        'Campo requerido'
                                }
                            ]}
                        >
                            <Input
                                placeholder="Ingrese nombre zona"
                                size="large"
                            />
                        </Form.Item>
                    </Col>
                    {/* DEPARTAMENTO */}
                    <Col xs={24} md={12}>
                        <Form.Item
                            label="Departamento"
                            name="departamento"
                            rules={[
                                {
                                    required: true,
                                    message:
                                        'Seleccione departamento'
                                }
                            ]}
                        >
                            <Select
                                size="large"
                                showSearch
                                placeholder="Seleccione"
                                optionFilterProp="label"
                                onChange={handleDepartamento}
                                options={departamentos.map(
                                    item => ({
                                        value: item.oid,
                                        label:
                                            item.departamento
                                    })
                                )}
                            />
                        </Form.Item>
                    </Col>
                    {/* MUNICIPIO */}
                    <Col xs={24} md={12}>
                        <Form.Item
                            label="Municipio"
                            name="id_municipio"
                            rules={[
                                {
                                    required: true,
                                    message:
                                        'Seleccione municipio'
                                }
                            ]}
                        >

                            <Select
                                size="large"
                                showSearch
                                placeholder="Seleccione"
                                optionFilterProp="label"
                                options={municipios.map(
                                    item => ({
                                        value: item.oid,
                                        label:
                                            item.municipio
                                    })
                                )}
                            />
                        </Form.Item>
                    </Col>
                    {/* TIPO */}
                    <Col xs={24}>
                        <Form.Item
                            label="Tipo Zona Influencia"
                            name="id_tipo_zona_influencia"
                            rules={[
                                {
                                    required: true,
                                    message:
                                        'Seleccione tipo'
                                }
                            ]}
                        >
                            <Select
                                size="large"
                                placeholder="Seleccione"
                                options={tipos.map(
                                    item => ({
                                        value: item.oid,
                                        label:
                                            item.tipo_zona_influencia
                                    })
                                )}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                {/* FOOTER */}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginTop: 24
                    }}
                >
                    <Space>
                        <Button
                            htmlType="button"
                            size="large"
                            onClick={() =>
                                form.resetFields()
                            }
                        >
                            Limpiar
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            loading={loading}
                        >
                            Guardar
                        </Button>
                    </Space>
                </div>
            </Form>
        </Spin>
    );
};

export default FormZonaInfluencia;